<template>
  <div>
    <v-snackbar top timeout="2000" color="success" v-model="snackbar">
      Copy เรียบร้อย
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-dialog
      v-model="dialog"
      transition="dialog-bottom-transition"
      width="500"
    >
      <v-card>
        <v-card-title class="headline grey lighten-2"
          >เพิ่ม Question
        </v-card-title>
        <v-card-text>
          <v-card flat>
            <v-card-text>
              <v-form ref="formcopy">
                <v-text-field
                  v-model="copy_amount"
                  label="จำนวนการ copy"
                  outlined
                  dense
                  type="number"
                  min="1"
                  max="10"
                  :rules="[
                    $store.getters.NumberRangeRule({
                      amount: copy_amount,
                      min: 1,
                      max: 10,
                    }),
                  ]"
                ></v-text-field>
                <!-- <v-checkbox
                  v-if="label.questionType !== 'end'"
                  v-model="checkbox"
                  label="ต่อคำถามต่อไปอัตโนมัติ"
                ></v-checkbox> -->
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="MultiCopyQuestion"> บันทึก </v-btn>
            </v-card-actions>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <code v-show="false">{{ visible }}</code>
    <v-alert
      border="left"
      colored-border
      :color="ColorTab"
      dense
      style="cursor: pointer"
      class="mb-0"
      v-show="label.show"
      @click="ExpandCard('label')"
    >
      <template #prepend>
        <div :class="[!$vuetify.breakpoint.mobile ? 'mx-6' : undefined]">
          <span v-if="type === 'connect' || type === 'start'">{{
            index + 1
          }}</span>
          <span v-else>{{ type }}</span>
        </div>
      </template>
      <v-container>
        <v-row align="center">
          <v-col class="grow">
            <v-row align="center" justify="end">
              <v-col cols="12" style="word-break: break-all">
                {{ label.questionLabel }}</v-col
              >
            </v-row>
          </v-col>
          <v-col class="shrink d-flex align-center justify-end">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <div v-if="label.editable"></div>
                <div v-else>
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    color="#D69120"
                    icon
                    v-show="QPermission.question.update"
                    v-if="!label.editable"
                    @click.stop="EditQuestion"
                    ><v-icon>border_color</v-icon></v-btn
                  >
                </div>
              </template>
              <span>แก้ไข</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <div v-if="label.editable"></div>
                <div v-else>
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    color="#30B79E"
                    v-if="type !== 'fail'"
                    v-show="QPermission.question.create"
                    icon
                    @click.stop="BeforeCopy"
                    ><v-icon>mdi-content-copy</v-icon></v-btn
                  >
                </div>
              </template>
              <span>คัดลอก</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <div v-if="type === 'fail' || questionlist.length <= 1"></div>
                <div v-else>
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    color="#DE4F3B"
                    icon
                    v-show="QPermission.question.delete"
                    v-if="!label.editable"
                    @click.stop="BeforeDel"
                    ><v-icon>mdi-trash-can-outline</v-icon></v-btn
                  >
                </div>
              </template>
              <span>ลบ</span>
            </v-tooltip>
            <slot
              v-if="QPermission.question.update && questionlist.length > 1"
              name="moveto"
            ></slot>
            <v-btn class="mx-2" icon @click.stop="ExpandCard('label')">
              <v-icon>{{
                show ? "mdi-chevron-up" : "mdi-chevron-down"
              }}</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-alert>
    <div v-show="!label.show"></div>
    <v-expand-transition pand-transition v-show="label.show">
      <v-card v-show="show" flat class="px-6 py-3" color="#F7F7F7">
        <v-container>
          <v-row class="mb-4">
            <v-col cols="12">
              <v-card flat color="transparent">
                <v-row align="center">
                  <v-col cols="12" md="2">
                    <span>หัวข้อคำถาม :</span>
                  </v-col>
                  <v-col class="d-flex align-center">
                    <span v-if="!label.editable" style="word-break: break-all">
                      {{ templabel.questionLabel }}</span
                    >
                    <v-text-field
                      v-else
                      v-model="templabel.questionLabel"
                      clearable
                      counter="100"
                      maxLength="100"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
          <v-card>
            <v-card-title> การตั้งคำถาม </v-card-title>
            <v-card-text>
              <Conversation
                :questioninfo="questioninfo"
                :Editing="label.editable"
              />
            </v-card-text>
          </v-card>
        </v-container>
        <v-form ref="form" v-show="type === 'connect' || type === 'start'">
          <ConditionCard
            :editable="label.editable"
            :questioninfo="questioninfo"
            :JumpQuestion="JumpQuestion"
            :NextQuestion="NextQuestion"
            :freetext="freetext"
            :fixtext="fixtext"
            :number="number"
            :multiselect="multiselect"
            :condition_selected="condition_selected"
            :freetext_notmatch="freetext_notmatch"
            :fixtext_notmatch="fixtext_notmatch"
            :number_notmatch="number_notmatch"
            :enableConditionChange="enableConditionChange"
            @fixtext-setdata="FixtextSetdata"
            @multiselect-setdata="MultiSelectSetdata"
            ref="cond"
          />
        </v-form>
        <v-card-actions v-if="label.editable">
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="#F06FAF"
            :disabled="!label.editable"
            @click="RestoreQuestionInfo"
            >ไม่บันทึก</v-btn
          >
          <v-btn
            color="#F06FAF"
            :disabled="!label.editable"
            class="white--text"
            @click="UpdateQuestionInfo"
            >บันทึก</v-btn
          >
        </v-card-actions>
        <v-card-actions v-else>
          <v-spacer></v-spacer>
          <v-btn
            color="warning"
            v-show="QPermission.question.update"
            v-if="!label.editable"
            @click.stop="EditQuestion"
            >แก้ไข</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-expand-transition>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import Conversation from "./Prequestion/Conversation/Conversation";
import ConditionCard from "../ConditionUI/ConditionCard";
export default {
  props: [
    "label",
    "visible",
    "type",
    "index",
    "questionlist",
    "JumpQuestion",
    "NextQuestion",
    "surveyStatus",
  ],
  components: { Conversation, ConditionCard },
  watch: {
    label: {
      handler: function () {
        this.templabel = JSON.parse(JSON.stringify(this.label));
        if (this.questioninfo) {
          if (this.label.questionID !== this.questioninfo.questionID) {
            this.getQuestionInfo();
          } else {
            if (this.surveyStatus) {
              if (
                this.$store.state.editingPreData?.questionID ===
                this.label.questionID
              ) {
                if (this.Editing) {
                  let restorelabel = this.$store.state.allquestion.find(
                    (id) => id.questionID === this.label.questionID
                  );
                  if (restorelabel) {
                    restorelabel.editable = true;
                  }
                }
                this.disable_menu = false;
              } else {
                if (this.Editing) {
                  let restorelabel = this.$store.state.allquestion.find(
                    (id) =>
                      id.questionID ===
                      this.$store.state.editingPreData?.questionID
                  );
                  if (restorelabel) {
                    restorelabel.editable = true;
                  }
                }
                this.disable_menu = true;
              }
            }
            if (
              this.$store.state.editingPreData &&
              this.label &&
              this.$store.state.editingPreData.questionID !==
                this.label.questionID
            ) {
              this.getQuestionInfoWithNewQID(this.label.questionID);
            }
          }
        }
      },
      deep: true,
    },
    surveyStatus(newValue, oldValue) {
      if (oldValue !== newValue) {
        this.disable_menu = newValue;
      }
    },
    ConfirmEditing() {
      if (
        this.$store.state.editingPreData &&
        this.label &&
        this.ConfirmEditing &&
        this.questioninfo &&
        this.$store.state.editingPreData.questionID === this.label.questionID
      ) {
        this.UpdateQuestionInfo();
      }
      if (this.$store.state.editingCurrent) {
        let openlabel = this.$store.state.allquestion.find(
          (id) => id.questionID === this.$store.state.editingCurrent.questionID
        );
        if (openlabel) {
          if (openlabel.questionID === this.label.questionID) {
            if (
              this.ConfirmEditing === false &&
              !(
                this.$store.state.editingPreData &&
                this.label &&
                this.ConfirmEditing &&
                this.questioninfo &&
                this.$store.state.editingPreData.questionID ===
                  this.label.questionID
              )
            )
              this.EditQuestion();
          }
        }
      }
    },
  },
  data() {
    return {
      snackbar: false,
      show: false,
      checkbox: false,
      passquestion: false,
      templabel: { questionLabel: "" },
      questioninfo: null,
      condition_selected: { conditiontype: null },
      copy_amount: 1,
      dialog: false,
      disable_menu: false,
      enableConditionChange: false,
      freetext: [
        {
          conditiontext: null,
          conditiontype: "freetext",
          hascompute: false,
          defaultCondition: {
            nextQuestionID: this.NextQuestion.questionID,
            score: 0,
          },
          computeCondition: {
            match: [
              {
                nextQuestionID: this.NextQuestion.questionID,
                operation: "",
                value: 0,
                value_from: 0,
                value_to: 0,
                score: 0,
                errorLabel: false,
                errorLabelMsg: "",
              },
            ],
            notmatch: {
              nextQuestionID: this.NextQuestion.questionID,
              score: 0,
            },
          },
        },
      ],
      fixtext: [
        {
          conditiontext: null,
          conditiontype: "fixtext",
          fixtext: "",
          errorLabel: false,
          errorLabelMsg: "",
          hascompute: false,
          defaultCondition: {
            nextQuestionID: this.NextQuestion.questionID,
            score: 0,
          },
          computeCondition: {
            match: [
              {
                nextQuestionID: this.NextQuestion.questionID,
                operation: "",
                value: 0,
                value_from: 0,
                value_to: 0,
                score: 0,
                errorLabel: false,
                errorLabelMsg: "",
              },
            ],
            notmatch: {
              nextQuestionID: this.NextQuestion.questionID,
              score: 0,
            },
          },
        },
      ],
      number: [
        {
          conditiontext: null,
          conditiontype: "number",
          number: { operation: "", value: 0, value_from: 0, value_to: 0 },
          errorLabel: false,
          errorLabelMsg: "",
          hascompute: false,
          defaultCondition: {
            nextQuestionID: this.NextQuestion.questionID,
            score: 0,
            scoreInput: false,
          },
          computeCondition: {
            match: [
              {
                nextQuestionID: this.NextQuestion.questionID,
                operation: "",
                value: 0,
                value_from: 0,
                value_to: 0,
                score: 0,
                errorLabel: false,
                errorLabelMsg: "",
              },
            ],
            notmatch: {
              nextQuestionID: this.NextQuestion.questionID,
              score: 0,
            },
          },
        },
      ],
      multiselect: [
        {
          conditiontext: null,
          conditiontype: "multiselect",
          selected: [
            {
              text: "",
              value: 0,
              description: false,
              errorLabel: false,
              errorLabelMsg: "",
            },
          ],
          min_selected: 1,
          max_selected: 1,
          hascompute: false,
          defaultCondition: {
            nextQuestionID: this.NextQuestion.questionID,
            score: 0,
          },
          computeCondition: {
            match: [
              {
                nextQuestionID: this.NextQuestion.questionID,
                operation: "",
                value: 0,
                value_from: 0,
                value_to: 0,
                score: 0,
                errorLabel: false,
                errorLabelMsg: "",
              },
            ],
            notmatch: {
              nextQuestionID: this.NextQuestion.questionID,
              score: 0,
            },
          },
        },
      ],
      freetext_notmatch: {
        nextQuestionID: null,
        score: 0,
      },
      fixtext_notmatch: {
        nextQuestionID: null,
        score: 0,
      },
      number_notmatch: {
        nextQuestionID: null,
        score: 0,
      },
    };
  },
  mounted() {
    if (this.label) {
      this.templabel = JSON.parse(JSON.stringify(this.label));
    }
    this.disable_menu = this.surveyStatus;
  },
  computed: {
    QPermission() {
      return this.$store.state.user_permission;
    },
    ColorTab() {
      let color = "";
      if (this.label.editable) {
        color = "orange";
      } else {
        if (this.type === "fail") {
          color = "#FB868E";
        } else if (this.type === "end") {
          color = "#38D3D1";
        } else {
          color = "#0278ae";
        }
      }
      return color;
    },
    ConfirmEditing() {
      return this.$store.state.editingConfirm.edit;
    },
    Editing() {
      return this.$store.state.editing;
    },
  },
  methods: {
    FixtextSetdata(data) {
      this.fixtext = data;
    },
    MultiSelectSetdata(data) {
      // console.log("MultiSelectSetdata", data);
      this.multiselect = data;
    },
    EditQuestion() {
      this.$store.dispatch("checkPackage").then(() => {
        if (this.Editing) {
          Swal.fire({
            text: `คุณมีการแก้ไข "${this.$store.state.editingPreData?.questionLabel}" ค้างไว้ คุณยังต้องการแก้ไขอยู่หรือไม่`,
            icon: "warning",
            focusConfirm: false,
            focusCancel: false,
            focusDeny: false,
            showConfirmButton: true,
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonColor: "#F06FAF",
            denyButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "บันทึก",
            denyButtonText: "ไม่บันทึก",
            cancelButtonText: "กลับไปแก้ไข",
          }).then((result) => {
            if (result.isConfirmed) {
              this.$store.state.editingCurrent = this.label;
              this.$nextTick(() => {
                this.$store.state.editingConfirm.edit = true;
              });
            } else if (result.isDenied) {
              this.$store.commit("ToggleEditing");
              let restorelabel = this.$store.state.allquestion.find(
                (id) =>
                  id.questionID === this.$store.state.editingPreData.questionID
              );
              if (restorelabel) {
                restorelabel.editable = false;
                this.$store.commit("UpdateQuestionPreEditing", this.label);
                if (this.surveyStatus) {
                  this.disable_menu = true;
                }
                this.BeforeExpand();
              }
            } else {
              this.$store.commit("BacktoEditing");
            }
          });
        } else {
          this.BeforeExpand();
          if (!this.$store.state.editingPreData) {
            this.$store.commit("UpdateQuestionPreEditing", this.label);
          }
        }
      });
    },
    BeforeExpand() {
      if (this.disable_menu) {
        Swal.fire({
          title: `แบบสอบถามนี้ถูกเปิดการใช้งานแล้ว`,
          text: "การแก้ไขคำถามจะทำให้ความน่าเชื่อถือลดลงและผู้ตอบแบบสอบถามจะได้รับคำถามที่ไม่เท่ากัน",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "ตกลง",
          cancelButtonText: "ปิด",
        }).then((result) => {
          if (result.isConfirmed) {
            this.$store
              .dispatch("CheckHaveAnswer", {
                surveyID: this.$route.params.surveyID,
                questionID: this.label.questionID,
              })
              .then((resp) => {
                // console.log(resp);
                this.enableConditionChange = resp.data.haveAnswer;
                this.label.editable = true;
                this.disable_menu = false;
                this.$store.commit("ToggleEditing");
                this.ExpandCard("editable");
              });
          }
        });
      } else {
        this.$store
          .dispatch("CheckHaveAnswer", {
            surveyID: this.$route.params.surveyID,
            questionID: this.label.questionID,
          })
          .then((resp) => {
            // console.log(resp);
            this.enableConditionChange = resp.data.haveAnswer;
            this.label.editable = true;
            this.$store.commit("ToggleEditing");
            this.ExpandCard("editable");
          });
      }
    },
    ExpandCard(clickfrom) {
      if (!this.questioninfo) {
        this.$store
          .dispatch("getQuestionInfo", this.label.questionID)
          .then((questioninfo) => {
            // // console.log(questioninfo);
            // // console.log(Object.keys(questioninfo).length);
            if (Object.keys(questioninfo).length > 0) {
              questioninfo.questions.map((q) => {
                if (q.type === "text") {
                  if (q.payload) {
                    q.text = q.payload.text;
                    delete q.payload;
                  }
                }
                if (q.type === "image") {
                  if (q.payload) {
                    q.url = q.payload.url;
                    delete q.payload;
                  }
                }
                if (q.type === "video") {
                  if (q.payload) {
                    q.url = q.payload.url;
                    delete q.payload;
                  }
                }
                if (q.type === "quickReply") {
                  if (q.payload) {
                    q.payload.buttons.map((b) => {
                      b.text = b.payload.text;
                      b.errorLabel = false;
                      b.errorLabelMsg = "";
                      delete b.payload;
                    });
                    q.text = q.payload.text;
                    q.buttons = q.payload.buttons;
                    delete q.payload;
                  }
                }
              });
              this.questioninfo = questioninfo;
              this.condition_selected.conditiontype =
                questioninfo.conditionType;
              this.FormatCondition();
              this.show = true;
            }
          })
          .catch((err) => {
            console.log(err);
            Swal.fire({
              icon: "error",
              text: "ไม่สามารถดูได้ ",
              title: "",
            });
          });
      } else {
        // // console.log(this.label.editable);
        if (clickfrom === "editable") {
          this.show = true;
        } else {
          this.show = !this.show;
        }
      }
    },
    getQuestionInfo(action) {
      this.$store
        .dispatch("getQuestionInfo", this.label.questionID)
        .then((questioninfo) => {
          if (Object.keys(questioninfo).length > 0) {
            questioninfo.questions.map((q) => {
              if (q.type === "text") {
                if (q.payload) {
                  q.text = q.payload.text;
                  delete q.payload;
                }
              }
              if (q.type === "image") {
                if (q.payload) {
                  q.url = q.payload.url;
                  delete q.payload;
                }
              }
              if (q.type === "video") {
                if (q.payload) {
                  q.url = q.payload.url;
                  delete q.payload;
                }
              }
              if (q.type === "quickReply") {
                if (q.payload) {
                  q.payload.buttons.map((b) => {
                    b.text = b.payload.text;
                    b.errorLabel = false;
                    b.errorLabelMsg = "";
                    delete b.payload;
                  });
                  q.text = q.payload.text;
                  q.buttons = q.payload.buttons;
                  delete q.payload;
                }
              }
            });
            this.questioninfo = questioninfo;
            this.templabel = JSON.parse(JSON.stringify(this.label));
            this.condition_selected.conditiontype = questioninfo.conditionType;
            if (this.surveyStatus) {
              this.disable_menu = true;
            }
            this.FormatCondition(action);
          }
        })
        .catch((err) => {
          if (err.data.message === "Permission Denied") {
            Swal.fire({
              icon: "warning",
              text: "สิทธิ์ของคุณถูกปฏิเสธ",
              title: "",
            }).then(() => {
              window.location.reload();
            });
          } else if (err.data.message === "Survey Not Avaliable.") {
            this.$store.commit("ToggleLoading");
          } else {
            this.RestoreQuestionInfo();
            Swal.fire({
              icon: "error",
              text: "ไม่สามารถดูได้",
              title: "",
            });
          }
        });
    },
    getQuestionInfoWithNewQID(qid) {
      this.$store
        .dispatch("getQuestionInfo", qid)
        .then((questioninfo) => {
          if (Object.keys(questioninfo).length > 0) {
            questioninfo.questions.map((q) => {
              if (q.type === "text") {
                if (q.payload) {
                  q.text = q.payload.text;
                  delete q.payload;
                }
              }
              if (q.type === "image") {
                if (q.payload) {
                  q.url = q.payload.url;
                  delete q.payload;
                }
              }
              if (q.type === "video") {
                if (q.payload) {
                  q.url = q.payload.url;
                  delete q.payload;
                }
              }
              if (q.type === "quickReply") {
                if (q.payload) {
                  q.payload.buttons.map((b) => {
                    b.text = b.payload.text;
                    b.errorLabel = false;
                    b.errorLabelMsg = "";
                    delete b.payload;
                  });
                  q.text = q.payload.text;
                  q.buttons = q.payload.buttons;
                  delete q.payload;
                }
              }
            });
            this.questioninfo = questioninfo;
            this.templabel = JSON.parse(JSON.stringify(this.label));
            this.condition_selected.conditiontype = questioninfo.conditionType;
            this.FormatCondition();
          }
        })
        .catch((err) => {
          if (err.data.message === "Permission Denied") {
            Swal.fire({
              icon: "warning",
              text: "สิทธิ์ของคุณถูกปฏิเสธ",
              title: "",
            }).then(() => {
              window.location.reload();
            });
          } else if (err.data.message === "Survey Not Avaliable.") {
            this.$store.commit("ToggleLoading");
          } else {
            this.RestoreQuestionInfo();
            Swal.fire({
              icon: "error",
              text: "ไม่สามารถดูได้",
              title: "",
            });
          }
        });
    },
    FormatCondition(action) {
      if (this.questioninfo) {
        switch (this.questioninfo.conditionType) {
          case "freetext":
            {
              let data = {
                conditiontext: null,
                conditiontype: "freetext",
                hascompute: false,
                defaultCondition: {
                  nextQuestionID: null,
                  score: 0,
                },
                computeCondition: {
                  match: [],
                  notmatch: {
                    nextQuestionID: null,
                    score: 0,
                  },
                },
              };
              let conditions;
              this.freetext_notmatch =
                this.questioninfo.conditionsAnswer.notmatch;
              conditions = this.questioninfo.conditionsAnswer;
              let match = conditions.match;
              if (match.length === 1) {
                data.defaultCondition.nextQuestionID = match[0].nextQuestionID;
                data.defaultCondition.score = match[0].value;
                if (Object.keys(match[0].score).length === 0) {
                  data.computeCondition.match.push({
                    nextQuestionID: match[0].nextQuestionID,
                    operation: "",
                    value: 0,
                    value_from: 0,
                    value_to: 0,
                    score: match[0].value,
                    errorLabel: false,
                    errorLabelMsg: "",
                  });
                } else {
                  data.hascompute = true;
                  data.computeCondition.match.push({
                    nextQuestionID: match[0].nextQuestionID,
                    operation: match[0].score.operation,
                    value: match[0].score.value[0],
                    value_from: match[0].score.value[0],
                    value_to:
                      match[0].score.operation === "><" ||
                      match[0].score.operation === "<>"
                        ? match[0].score.value[1]
                        : 0,
                    score: match[0].value,
                    errorLabel: false,
                    errorLabelMsg: "",
                  });
                }
              } else {
                data.hascompute = true;
                let notmatch = match.find((c) => c.score.operation === "!!");
                if (notmatch) {
                  data.computeCondition.notmatch.nextQuestionID =
                    notmatch.nextQuestionID;
                  data.computeCondition.notmatch.score = notmatch.value;
                }
                this.$delete(
                  match,
                  match.findIndex((c) => c.score.operation === "!!")
                );
                match.map((cond) => {
                  data.defaultCondition.nextQuestionID = cond.nextQuestionID;
                  data.defaultCondition.score = cond.value;
                  data.computeCondition.match.push({
                    nextQuestionID: cond.nextQuestionID,
                    operation: cond.score.operation,
                    value: cond.score.value[0],
                    value_from: cond.score.value[0],
                    value_to:
                      cond.score.operation === "><" ||
                      cond.score.operation === "<>"
                        ? cond.score.value[1]
                        : 0,
                    score: cond.value,
                    errorLabel: false,
                    errorLabelMsg: "",
                  });
                });
              }
              // console.log(conditions);
              // console.log(data);
              this.freetext = [data];
            }
            break;
          case "fixtext":
            {
              let tempfixtext = [];
              let conditions;
              this.fixtext_notmatch =
                this.questioninfo.conditionsAnswer.notmatch;
              conditions = this.questioninfo.conditionsAnswer;
              let match = conditions.match;
              let allname = [];
              match.map((cond) => {
                let data = {
                  conditiontext: null,
                  conditiontype: "fixtext",
                  fixtext: "",
                  errorLabel: false,
                  errorLabelMsg: "",
                  hascompute: false,
                  defaultCondition: {
                    nextQuestionID: null,
                    score: 0,
                  },
                  computeCondition: {
                    match: [],
                    notmatch: {
                      nextQuestionID: null,
                      score: 0,
                    },
                  },
                };
                let fixname = cond.fixtext[0];
                let dup = tempfixtext.find((text) => text.fixtext === fixname);
                if (dup) {
                  if (cond.score.operation === "!!") {
                    dup.computeCondition.notmatch.nextQuestionID =
                      cond.nextQuestionID;
                    dup.computeCondition.notmatch.score = cond.value;
                  } else {
                    dup.computeCondition.match.push({
                      nextQuestionID: cond.nextQuestionID,
                      operation: cond.score.operation,
                      value: cond.score.value[0],
                      value_from: cond.score.value[0],
                      value_to:
                        cond.score.operation === "><" ||
                        cond.score.operation === "<>"
                          ? cond.score.value[1]
                          : 0,
                      score: cond.value,
                      errorLabel: false,
                      errorLabelMsg: "",
                    });
                  }
                } else {
                  data.fixtext = fixname;
                  data.defaultCondition.nextQuestionID = cond.nextQuestionID;
                  data.defaultCondition.score = cond.value;
                  if (Object.keys(cond.score).length === 0) {
                    data.computeCondition.match.push({
                      nextQuestionID: cond.nextQuestionID,
                      operation: "",
                      value: 0,
                      value_from: 0,
                      value_to: 0,
                      score: cond.value,
                      errorLabel: false,
                      errorLabelMsg: "",
                    });
                  } else {
                    data.hascompute = true;
                    data.computeCondition.match.push({
                      nextQuestionID: cond.nextQuestionID,
                      operation: cond.score.operation,
                      value: cond.score.value[0],
                      value_from: cond.score.value[0],
                      value_to:
                        cond.score.operation === "><" ||
                        cond.score.operation === "<>"
                          ? cond.score.value[1]
                          : 0,
                      score: cond.value,
                      errorLabel: false,
                      errorLabelMsg: "",
                    });
                  }
                  tempfixtext.push(data);
                }
                allname.push(fixname);
              });
              // console.log(tempfixtext);
              this.fixtext = tempfixtext;
              if (action === "restore") {
                if (this.questioninfo) {
                  let lastquestion =
                    this.questioninfo.questions[
                      this.questioninfo.questions.length - 1
                    ];
                  if (lastquestion) {
                    this.$refs.cond.RestoreFixtext(
                      tempfixtext,
                      lastquestion.type
                    );
                  }
                }
              }
            }
            break;
          case "number":
            {
              let tempnumber = [];
              let conditions;
              this.number_notmatch =
                this.questioninfo.conditionsAnswer.notmatch;
              conditions = this.questioninfo.conditionsAnswer;
              let match = conditions.match;
              let allname = [];
              match.map((cond) => {
                // console.log(cond);
                let data = {
                  conditiontext: null,
                  conditiontype: "number",
                  number: {
                    operation: "",
                    value: 0,
                    value_from: 0,
                    value_to: 0,
                  },
                  numbertext: "",
                  errorLabel: false,
                  errorLabelMsg: "",
                  hascompute: false,
                  defaultCondition: {
                    nextQuestionID: null,
                    score: 0,
                    scoreInput: false,
                  },
                  computeCondition: {
                    match: [],
                    notmatch: {
                      nextQuestionID: null,
                      score: 0,
                    },
                  },
                };
                data.number.operation = cond.number.operation;
                data.number.value = cond.number.value[0];
                data.number.value_from = cond.number.value[0];
                data.number.value_to =
                  cond.number.operation === "><" ||
                  cond.number.operation === "<>"
                    ? cond.number.value[1]
                    : 0;
                let fixname = `${data.number.operation}|${
                  data.number.operation === "><" ||
                  data.number.operation === "<>"
                    ? `${data.number.value_from}|${data.number.value_to}`
                    : data.number.value
                }`;
                let dup = tempnumber.find(
                  (text) => text.numbertext === fixname
                );
                if (dup) {
                  if (cond.score.operation === "!!") {
                    dup.computeCondition.notmatch.nextQuestionID =
                      cond.nextQuestionID;
                    dup.computeCondition.notmatch.score = cond.value;
                    dup.defaultCondition.scoreInput = cond.valueInput;
                  } else {
                    dup.computeCondition.match.push({
                      nextQuestionID: cond.nextQuestionID,
                      operation: cond.score.operation,
                      value: cond.score.value[0],
                      value_from: cond.score.value[0],
                      value_to:
                        cond.score.operation === "><" ||
                        cond.score.operation === "<>"
                          ? cond.score.value[1]
                          : 0,
                      score: cond.value,
                      errorLabel: false,
                      errorLabelMsg: "",
                    });
                  }
                } else {
                  data.numbertext = fixname;
                  data.defaultCondition.nextQuestionID = cond.nextQuestionID;
                  data.defaultCondition.score = cond.value;
                  data.defaultCondition.scoreInput = cond.valueInput;
                  if (Object.keys(cond.score).length === 0) {
                    data.computeCondition.match.push({
                      nextQuestionID: cond.nextQuestionID,
                      operation: "",
                      value: 0,
                      value_from: 0,
                      value_to: 0,
                      score: cond.value,
                      errorLabel: false,
                      errorLabelMsg: "",
                    });
                  } else {
                    data.hascompute = true;
                    data.computeCondition.match.push({
                      nextQuestionID: cond.nextQuestionID,
                      operation: cond.score.operation,
                      value: cond.score.value[0],
                      value_from: cond.score.value[0],
                      value_to:
                        cond.score.operation === "><" ||
                        cond.score.operation === "<>"
                          ? cond.score.value[1]
                          : 0,
                      score: cond.value,
                      errorLabel: false,
                      errorLabelMsg: "",
                    });
                  }
                  tempnumber.push(data);
                }
                allname.push(fixname);
              });
              // console.log(tempnumber);
              this.number = tempnumber;
              // console.log("number");
            }
            break;
          case "multiselect":
            {
              let data = {
                conditiontext: null,
                conditiontype: "multiselect",
                selected: [],
                min_selected: 1,
                max_selected: 1,
                hascompute: false,
                defaultCondition: {
                  nextQuestionID: null,
                  score: 0,
                },
                computeCondition: {
                  match: [],
                  notmatch: {
                    nextQuestionID: null,
                    score: 0,
                  },
                },
              };
              let conditions;
              conditions = this.questioninfo.conditionsAnswer;
              let match = conditions.match;
              if (match.length === 1) {
                data.defaultCondition.nextQuestionID = match[0].nextQuestionID;
                data.defaultCondition.score = match[0].value;
                match[0].choice.map((c) => {
                  // console.log(c);
                  data.selected.push({
                    text: c.text,
                    value: +c.value,
                    description: c.description,
                    errorLabel: false,
                    errorLabelMsg: "",
                  });
                });
                data.min_selected = match[0].min;
                data.max_selected = match[0].max;
                if (Object.keys(match[0].score).length === 0) {
                  data.computeCondition.match.push({
                    nextQuestionID: match[0].nextQuestionID,
                    operation: "",
                    value: 0,
                    value_from: 0,
                    value_to: 0,
                    score: match[0].value,
                    errorLabel: false,
                    errorLabelMsg: "",
                  });
                } else {
                  data.hascompute = true;
                  data.computeCondition.match.push({
                    nextQuestionID: match[0].nextQuestionID,
                    operation: match[0].score.operation,
                    value: match[0].score.value[0],
                    value_from: match[0].score.value[0],
                    value_to:
                      match[0].score.operation === "><" ||
                      match[0].score.operation === "<>"
                        ? match[0].score.value[1]
                        : 0,
                    score: match[0].value,
                    errorLabel: false,
                    errorLabelMsg: "",
                  });
                }
              } else {
                data.hascompute = true;
                let notmatch = match.find((c) => c.score.operation === "!!");
                if (notmatch) {
                  data.computeCondition.notmatch.nextQuestionID =
                    notmatch.nextQuestionID;
                  data.computeCondition.notmatch.score = notmatch.value;
                }
                this.$delete(
                  match,
                  match.findIndex((c) => c.score.operation === "!!")
                );
                match[0].choice.map((c) => {
                  data.selected.push({
                    text: c.text,
                    value: +c.value,
                    description: c.description,
                    errorLabel: false,
                    errorLabelMsg: "",
                  });
                });
                data.min_selected = match[0].min;
                data.max_selected = match[0].max;
                match.map((cond) => {
                  data.defaultCondition.nextQuestionID = cond.nextQuestionID;
                  data.defaultCondition.score = cond.value;
                  data.computeCondition.match.push({
                    nextQuestionID: cond.nextQuestionID,
                    operation: cond.score.operation,
                    value: cond.score.value[0],
                    value_from: cond.score.value[0],
                    value_to:
                      cond.score.operation === "><" ||
                      cond.score.operation === "<>"
                        ? cond.score.value[1]
                        : 0,
                    score: cond.value,
                    errorLabel: false,
                    errorLabelMsg: "",
                  });
                });
              }
              // console.log(conditions);
              // console.log(data);
              this.multiselect = [data];
              if (action === "restore") {
                if (this.questioninfo) {
                  let lastquestion =
                    this.questioninfo.questions[
                      this.questioninfo.questions.length - 1
                    ];
                  if (lastquestion) {
                    this.$refs.cond.RestoreMultiSelect(
                      [data],
                      lastquestion.type
                    );
                  }
                }
              }
            }
            break;
        }
      }
    },
    BeforeDel() {
      if (
        this.Editing &&
        this.$store.state.editingPreData &&
        this.label.questionID !== this.$store.state.editingPreData?.questionID
      ) {
        Swal.fire({
          title: "",
          text: `คุณมีการแก้ไข "${this.$store.state.editingPreData?.questionLabel}" ค้างไว้ กรุณาดำเนินการให้เรียบร้อย`,
          icon: "warning",
          confirmButtonText: "ตกลง",
          customClass: {
            popup: "format-pre",
          },
        }).then(() => {
          this.$store.commit("BacktoEditing");
        });
      } else {
        this.ConfirmDel();
      }
    },
    ConfirmDel() {
      if (this.disable_menu) {
        Swal.fire({
          title: `แบบสอบถามนี้ถูกเปิดการใช้งานแล้ว`,
          text: "การแก้ไขคำถามจะทำให้ความน่าเชื่อถือลดลงและผู้ตอบแบบสอบถามจะได้รับคำถามที่ไม่เท่ากัน",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "ตกลง",
          cancelButtonText: "ปิด",
        }).then((result) => {
          if (result.isConfirmed) {
            this.DeleteQuestion();
          }
        });
      } else {
        this.DeleteQuestion();
      }
    },
    async DeleteQuestion() {
      let questionlist = this.$store.state.allquestion.filter(
        (q) => q.questionType === "start" || q.questionType === "connect"
      );
      let previousQuestionID = [];
      this.$store.commit("ToggleLoading");
      await Promise.all(
        questionlist.map(async (element) => {
          let questioninfo = await this.$store.dispatch(
            "getQuestionInfoDel",
            element.questionID
          );
          if (Object.keys(questioninfo).length > 0) {
            questioninfo.conditionsAnswer.match.map((next) => {
              if (next.nextQuestionID === this.label.questionID) {
                previousQuestionID.push({ label: element.questionLabel });
              }
            });
          }
        })
      );
      this.$store.commit("ToggleLoading");
      Swal.fire({
        text:
          previousQuestionID.length > 0
            ? `คำถามนี้มีการใช้งานกับคำถามอื่นอยู่ คุณต้องการจะลบหรือไม่`
            : `คุณต้องการจะลบหรือไม่`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ตกลง",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("DeleteQuestionLabel", {
              questionID: this.label.questionID,
            })
            .then(() => {
              Swal.fire({
                icon: "success",
                text: "ลบข้อมูลสำเร็จ",
                title: "",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                // this.RestoreQuestionInfo()
                // this.$delete(
                //   this.$store.state.allquestion,
                //   this.$store.state.allquestion.findIndex(
                //     (q) => q.questionID === this.label.questionID
                //   )
                // );
                // if (this.surveyStatus) {
                //   this.disable_menu = true;
                // }
                // this.$store.commit("ToggleEditing");
                // this.$store.commit("UpdateQuestionPreEditing", null);
                this.$store.dispatch("getQuestionLabel", this.$route.params);
              });
            })
            .catch((err) => {
              if (err.data.message === "Permission Denied") {
                Swal.fire({
                  icon: "warning",
                  text: "สิทธิ์ของคุณถูกปฏิเสธ",
                  title: "",
                }).then(() => {
                  window.location.reload();
                });
              } else if (err.data.message === "Survey Not Avaliable.") {
                this.$store.commit("ToggleLoading");
              } else {
                this.RestoreQuestionInfo();
                Swal.fire({
                  icon: "error",
                  text: "ไม่สามารถลบข้อมูลได้",
                  title: "",
                });
              }
            });
        }
      });
    },
    BeforeCopy() {
      if (this.Editing) {
        Swal.fire({
          title: "",
          text: `คุณมีการแก้ไข "${this.$store.state.editingPreData.questionLabel}" ค้างไว้ กรุณาดำเนินการให้เรียบร้อย`,
          icon: "warning",
          confirmButtonText: "ตกลง",
          customClass: {
            popup: "format-pre",
          },
        }).then(() => {
          this.$store.commit("BacktoEditing");
        });
      } else {
        this.PopupCopy();
      }
    },
    PopupCopy() {
      if (this.disable_menu) {
        Swal.fire({
          title: `แบบสอบถามนี้ถูกเปิดการใช้งานแล้ว`,
          text: "การแก้ไขคำถามจะทำให้ความน่าเชื่อถือลดลงและผู้ตอบแบบสอบถามจะได้รับคำถามที่ไม่เท่ากัน",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "ตกลง",
          cancelButtonText: "ปิด",
        }).then((result) => {
          if (result.isConfirmed) {
            this.dialog = true;
          }
        });
      } else {
        this.dialog = true;
      }
    },
    MultiCopyQuestion() {
      if (this.$refs.formcopy.validate()) {
        let copied = JSON.parse(JSON.stringify(this.label));
        copied.questionLabel = copied.questionLabel + "_copy";
        if (copied.questionType === "start") {
          copied.questionType = "connect";
        }
        let lastindex =
          this.questionlist[this.questionlist.length - 1].indexing;
        copied.indexing = lastindex + 1;
        // console.log(copied);
        this.$store
          .dispatch("getQuestionInfo", copied.questionID)
          .then((questioninfo) => {
            // console.log(questioninfo);
            if (Object.keys(questioninfo).length > 0) {
              delete questioninfo.questionLabel;
              delete questioninfo.questionType;
              // console.log({ ...copied, ...questioninfo });
              this.$store
                .dispatch("MultiCopyQuestion", {
                  copy: this.copy_amount,
                  data: { ...copied, ...questioninfo },
                  previousID: copied.questionID,
                  endID:
                    copied.questionType === "end"
                      ? null
                      : this.JumpQuestion.end[0].questionID,
                  auto: this.checkbox,
                })
                .then(() => {
                  this.snackbar = true;
                  this.dialog = false;
                  // this.$store.state.allquestion.push(...resp);
                  // this.checkbox = true;
                  this.$store.dispatch("getQuestionLabel", this.$route.params);
                })
                .catch((err) => {
                  if (err.data.message === "Permission Denied") {
                    Swal.fire({
                      icon: "warning",
                      text: "สิทธิ์ของคุณถูกปฏิเสธ",
                      title: "",
                    }).then(() => {
                      window.location.reload();
                    });
                  } else if (err.data.message === "Survey Not Avaliable.") {
                    this.$store.commit("ToggleLoading");
                  }
                  // this.$store.commit("ToggleLoading");
                });
            }
          })
          .catch((err) => {
            if (err.data.message === "Permission Denied") {
              Swal.fire({
                icon: "warning",
                text: "สิทธิ์ของคุณถูกปฏิเสธ",
                title: "",
              }).then(() => {
                window.location.reload();
              });
            } else if (err.data.message === "Survey Not Avaliable.") {
              this.$store.commit("ToggleLoading");
            } else {
              this.RestoreQuestionInfo();
              Swal.fire({
                icon: "error",
                text: "ไม่สามารถ copy ได้",
                title: "",
              });
            }
          });
      }
    },
    UpdateQuestionInfo() {
      if (this.$refs.form.validate()) {
        this.label.questionLabel = this.templabel.questionLabel;
        let tempquestion = JSON.parse(
          JSON.stringify(this.questioninfo.questions)
        );
        if (tempquestion.length <= 0) {
          Swal.fire({
            icon: "warning",
            text: "ต้องมีอย่างน้อย 1 คำถาม",
            title: "",
          });
          this.$store.state.editingConfirm.edit = false;
          this.$store.commit("BacktoEditing");
        } else {
          if (
            this.label.questionLabel === "" ||
            this.label.questionLabel === null
          ) {
            let lastqname = tempquestion[tempquestion.length - 1];
            if (lastqname.type === "text") {
              this.label.questionLabel = lastqname.text;
              this.templabel.questionLabel = lastqname.text;
            }
            if (lastqname.type === "image") {
              this.label.questionLabel = "รูปภาพ";
              this.templabel.questionLabel = "รูปภาพ";
            }
            if (lastqname.type === "quickReply") {
              this.label.questionLabel = lastqname.text;
              this.templabel.questionLabel = lastqname.text;
            }
            if (lastqname.type === "video") {
              this.label.questionLabel = "วิดีโอ";
              this.templabel.questionLabel = "วิดีโอ";
            }
          }
          // console.log(this.label);
          tempquestion.map((q) => {
            if (q.type === "text") {
              q.payload = { text: q.text };
              delete q.text;
            }
            if (q.type === "image") {
              q.payload = { url: q.url };
              delete q.url;
            }
            if (q.type === "video") {
              q.payload = { url: q.url };
              delete q.url;
            }
            if (q.type === "quickReply") {
              q.buttons.map((b) => {
                b.payload = {
                  text: b.text,
                  payload: b.text,
                };
                delete b.text;
                delete b.errorLabel;
                delete b.errorLabelMsg;
              });
              q.payload = {
                text: q.text,
                buttons: q.buttons,
              };
              delete q.text;
              delete q.buttons;
            }
          });
          let tempcondition = {
            questions: tempquestion,
            conditionType: this.condition_selected.conditiontype,
            conditionsAnswer: {
              match: [],
              notmatch: {
                nextQuestionID: null,
                score: 0,
              },
              failCaseID: null,
            },
          };
          let noerror = false;
          switch (this.condition_selected.conditiontype) {
            case "freetext":
              {
                this.freetext.map((freetext) => {
                  if (freetext.hascompute) {
                    freetext.computeCondition.match.map((compute) => {
                      if (compute.errorLabel) {
                        noerror = true;
                      }
                      let tempdata = {
                        nextQuestionID: compute.nextQuestionID,
                        score: {
                          operation: compute.operation,
                          value:
                            compute.operation === "><" ||
                            compute.operation === "<>"
                              ? [+compute.value_from, +compute.value_to]
                              : [+compute.value],
                        },
                        value: +freetext.defaultCondition.score,
                      };
                      tempdata.score.value.sort((a, b) => a - b);
                      tempcondition.conditionsAnswer.match.push(tempdata);
                    });
                    tempcondition.conditionsAnswer.match.push({
                      nextQuestionID:
                        freetext.computeCondition.notmatch.nextQuestionID,
                      score: {
                        operation: "!!",
                        value: 0,
                      },
                      value: +freetext.defaultCondition.score,
                    });
                  } else {
                    tempcondition.conditionsAnswer.match.push({
                      nextQuestionID: freetext.defaultCondition.nextQuestionID,
                      score: {},
                      value: +freetext.defaultCondition.score,
                    });
                  }
                  // tempcondition.conditionsAnswer.notmatch.nextQuestionID =
                  //   freetext.notmatch.nextQuestionID;
                  // tempcondition.conditionsAnswer.notmatch.score = freetext.notmatch.score;
                });
                tempcondition.conditionsAnswer.notmatch =
                  this.freetext_notmatch;
              }
              break;
            case "fixtext":
              {
                this.fixtext.map((fixtext) => {
                  if (fixtext.errorLabel) {
                    noerror = true;
                  }
                  if (fixtext.hascompute) {
                    fixtext.computeCondition.match.map((compute) => {
                      if (compute.errorLabel) {
                        noerror = true;
                      }

                      let tempdata = {
                        fixtext: [fixtext.fixtext],
                        nextQuestionID: compute.nextQuestionID,
                        score: {
                          operation: compute.operation,
                          value:
                            compute.operation === "><" ||
                            compute.operation === "<>"
                              ? [+compute.value_from, +compute.value_to]
                              : [+compute.value],
                        },
                        value: +fixtext.defaultCondition.score,
                      };
                      tempdata.score.value.sort((a, b) => a - b);
                      tempcondition.conditionsAnswer.match.push(tempdata);
                    });
                    tempcondition.conditionsAnswer.match.push({
                      fixtext: [fixtext.fixtext],
                      nextQuestionID:
                        fixtext.computeCondition.notmatch.nextQuestionID,
                      score: {
                        operation: "!!",
                        value: 0,
                      },
                      value: +fixtext.defaultCondition.score,
                    });
                  } else {
                    tempcondition.conditionsAnswer.match.push({
                      fixtext: [fixtext.fixtext],
                      nextQuestionID: fixtext.defaultCondition.nextQuestionID,
                      score: {},
                      value: +fixtext.defaultCondition.score,
                    });
                  }
                  // tempcondition.conditionsAnswer.notmatch.nextQuestionID =
                  //   fixtext.notmatch.nextQuestionID;
                  // tempcondition.conditionsAnswer.notmatch.score = fixtext.notmatch.score;
                });
                tempcondition.conditionsAnswer.notmatch = this.fixtext_notmatch;
              }
              break;
            case "number":
              {
                this.number.map((number) => {
                  if (number.errorLabel) {
                    noerror = true;
                  }
                  if (number.hascompute) {
                    number.computeCondition.match.map((compute) => {
                      if (compute.errorLabel) {
                        noerror = true;
                      }
                      let tempdata = {
                        number: {
                          operation: number.number.operation,
                          value:
                            number.number.operation === "><" ||
                            number.number.operation === "<>"
                              ? [
                                  +number.number.value_from,
                                  +number.number.value_to,
                                ]
                              : [+number.number.value],
                        },
                        nextQuestionID: compute.nextQuestionID,
                        score: {
                          operation: compute.operation,
                          value:
                            compute.operation === "><" ||
                            compute.operation === "<>"
                              ? [+compute.value_from, +compute.value_to]
                              : [+compute.value],
                        },
                        value: +number.defaultCondition.score,
                        valueInput: number.defaultCondition.scoreInput,
                      };
                      tempdata.score.value.sort((a, b) => a - b);
                      tempdata.number.value.sort((a, b) => a - b);
                      tempcondition.conditionsAnswer.match.push(tempdata);
                    });
                    let tempdata2 = {
                      number: {
                        operation: number.number.operation,
                        value:
                          number.number.operation === "><" ||
                          number.number.operation === "<>"
                            ? [
                                +number.number.value_from,
                                +number.number.value_to,
                              ]
                            : [+number.number.value],
                      },
                      nextQuestionID:
                        number.computeCondition.notmatch.nextQuestionID,
                      score: {
                        operation: "!!",
                        value: 0,
                      },
                      value: +number.defaultCondition.score,
                      valueInput: number.defaultCondition.scoreInput,
                    };
                    tempdata2.number.value.sort((a, b) => a - b);
                    tempcondition.conditionsAnswer.match.push(tempdata2);
                  } else {
                    let tempdata3 = {
                      number: {
                        operation: number.number.operation,
                        value:
                          number.number.operation === "><" ||
                          number.number.operation === "<>"
                            ? [
                                +number.number.value_from,
                                +number.number.value_to,
                              ]
                            : [+number.number.value],
                      },
                      nextQuestionID: number.defaultCondition.nextQuestionID,
                      score: {},
                      value: +number.defaultCondition.score,
                      valueInput: number.defaultCondition.scoreInput,
                    };
                    tempdata3.number.value.sort((a, b) => a - b);
                    tempcondition.conditionsAnswer.match.push(tempdata3);
                  }
                  // tempcondition.conditionsAnswer.notmatch.nextQuestionID =
                  //   fixtext.notmatch.nextQuestionID;
                  // tempcondition.conditionsAnswer.notmatch.score = fixtext.notmatch.score;
                });
                tempcondition.conditionsAnswer.notmatch = this.number_notmatch;
              }
              break;
            case "multiselect":
              {
                this.multiselect.map((multiselect) => {
                  if (multiselect.selected.length > 0) {
                    multiselect.selected.map((choice) => {
                      if (choice.errorLabel) {
                        noerror = true;
                      }
                    });
                  }
                  if (multiselect.hascompute) {
                    let s = multiselect.selected;
                    s.map((c) => {
                      if (c.errorLabel) {
                        noerror = true;
                      }
                      return { description: "", text: c.text, value: +c.value };
                    });
                    multiselect.computeCondition.match.map((compute) => {
                      if (compute.errorLabel) {
                        noerror = true;
                      }
                      let tempdata = {
                        choice: [...s],
                        min: +multiselect.min_selected,
                        max: +multiselect.max_selected,
                        nextQuestionID: compute.nextQuestionID,
                        score: {
                          operation: compute.operation,
                          value:
                            compute.operation === "><" ||
                            compute.operation === "<>"
                              ? [+compute.value_from, +compute.value_to]
                              : [+compute.value],
                        },
                        value: +multiselect.defaultCondition.score,
                      };
                      tempdata.score.value.sort((a, b) => a - b);
                      tempcondition.conditionsAnswer.match.push(tempdata);
                    });
                    tempcondition.conditionsAnswer.match.push({
                      nextQuestionID:
                        multiselect.computeCondition.notmatch.nextQuestionID,
                      score: {
                        operation: "!!",
                        value: 0,
                      },
                      value: +multiselect.defaultCondition.score,
                    });
                  } else {
                    let s = multiselect.selected;
                    s.map((c) => {
                      return { description: "", text: c.text, value: +c.value };
                    });
                    tempcondition.conditionsAnswer.match.push({
                      choice: [...s],
                      min: +multiselect.min_selected,
                      max: +multiselect.max_selected,
                      nextQuestionID:
                        multiselect.defaultCondition.nextQuestionID,
                      score: {},
                      value: +multiselect.defaultCondition.score,
                    });
                  }
                  // tempcondition.conditionsAnswer.notmatch.nextQuestionID =
                  //   freetext.notmatch.nextQuestionID;
                  // tempcondition.conditionsAnswer.notmatch.score = freetext.notmatch.score;
                });
              }
              break;
          }
          if (!noerror) {
            // console.log({ ...this.label, ...tempcondition });
            this.$store
              .dispatch("UpdateQuestionInfo", {
                ...this.label,
                ...tempcondition,
              })
              .then(() => {
                Swal.fire({
                  icon: "success",
                  text: "แก้ไขข้อมูลสำเร็จ",
                  title: "",
                  showConfirmButton: false,
                  timer: 1000,
                }).then(() => {
                  this.show = false;
                  this.label.editable = false;
                  if (this.surveyStatus) {
                    this.disable_menu = true;
                  }
                  this.$store.commit("UpdateQuestionPreEditing", null);
                  this.$store.state.editingConfirm.edit = false;
                  this.$store.commit("ToggleEditing");
                });
              })
              .catch((err) => {
                if (err.data.message === "Permission Denied") {
                  Swal.fire({
                    icon: "warning",
                    text: "สิทธิ์ของคุณถูกปฏิเสธ",
                    title: "",
                  }).then(() => {
                    window.location.reload();
                  });
                } else if (err.data.message === "Survey Not Avaliable.") {
                  this.$store.commit("ToggleLoading");
                }
                // this.$store.commit("ToggleLoading");
              });
          } else {
            Swal.fire({
              icon: "warning",
              text: "มีเงื่อนไขซ้ำกัน กรุณาตรวจสอบอีกครั้ง",
              title: "",
            });
            this.$store.state.editingConfirm.edit = false;
          }
        }
      } else {
        this.$store.state.editingConfirm.edit = false;
        Swal.fire({
          icon: "warning",
          text: "คุณยังกรอกข้อมูลไม่ครบหรือมีข้อผิดพลาด กรุณาตรวจสอบอีกครั้ง",
          title: "",
        }).then(() => {
          this.$store.commit("BacktoEditing");
        });
      }
    },
    RestoreQuestionInfo() {
      this.$store.commit("ToggleEditing");
      this.getQuestionInfo("restore");
      this.label.editable = false;
      this.$store.commit("UpdateQuestionPreEditing", null);
      // let restorelabel = this.$store.state.allquestion.find(
      //   (id) => id.questionID === this.$store.state.editingPreData.questionID
      // );
      // if (restorelabel) {
      //   restorelabel.editable = false;
      //   this.$store.commit("UpdateQuestionPreEditing", this.label);
      //   if (this.surveyStatus) {
      //     this.disable_menu = true;
      //   }
      // }
    },
  },
};
</script>

<style scoped></style>
